<template>
  <div id="app">
    <router-view/>
    <!-- 微信客服抽屉 -->
    <div class="wechat-drawer-mask" v-if="showDrawer" @click="toggleDrawer"></div>
    <div class="wechat-drawer" :class="{active: showDrawer}">
      <div class="drawer-body">
        <div class="drawer-header">
          <h3>联系客服</h3>
          <div class="close-btn" @click="toggleDrawer">
            <i class="el-icon-close"></i>
          </div>
        </div>
        
        <div class="service-info-section">
          <div class="contact-info">
            <h4>🔥 {{ siteName || '永盛制冷维修' }}</h4>
            <p class="service-desc">专业家电维修 · {{ serviceHours || '24小时服务' }}</p>
          </div>
          
          <div class="contact-methods">
            <div class="contact-item">
              <div class="contact-icon phone">
                <i class="el-icon-phone"></i>
              </div>
                          <div class="contact-detail">
              <span class="label">服务热线</span>
              <span class="value">{{ companyPhone || '13471579359' }}</span>
              <span class="note">24小时接听</span>
            </div>
            </div>
            
            <div class="contact-item">
              <div class="contact-icon wechat">
                <i class="el-icon-chat-dot-round"></i>
              </div>
              <div class="contact-detail">
                <span class="label">微信客服</span>
                <span class="value">A13471579359</span>
                <span class="note">在线咨询更便捷</span>
              </div>
            </div>
          </div>
        </div>

        <div class="qr-section">
          <img src="/images/微信二维码.jpg" alt="微信二维码" class="wechat-qrcode">
          <p class="qr-hint">
            <i class="el-icon-mobile-phone"></i>
            长按识别二维码添加客服微信
          </p>
        </div>

        <div class="service-features">
          <div class="feature-item">
            <i class="el-icon-time"></i>
            <span>快速响应</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-medal"></i>
            <span>专业团队</span>
          </div>
          <div class="feature-item">
            <i class="el-icon-location"></i>
            <span>上门服务</span>
          </div>
        </div>

        <div class="tips-section">
          <p class="tips-title">💡 温馨提示</p>
          <ul class="tips-list">
            <li>添加微信可随时查看维修进度</li>
            <li>支持图片视频描述故障问题</li>
            <li>享受专属客服一对一服务</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 触发按钮 -->
    <div class="wechat-trigger" @click="toggleDrawer">
      <i class="el-icon-chat-dot-round"></i>
    </div>
    <!-- 全局版权信息 -->
    <footer class="global-footer">
      <div class="footer-content">
        <p>{{ copyrightText }}</p>
        <p class="icp-info">备案号：{{ icpRecord || '（暂时为空）' }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import settingsService from './services/settingsService'

export default {
  name: 'App',
  data() {
    return {
      showDrawer: false,
      // 系统设置数据
      siteName: '永盛制冷维修有限公司',
      companyPhone: '',
      companyAddress: '',
      serviceHours: '24小时服务',
      icpRecord: '',
      copyrightText: '© 2025 永盛制冷维修有限公司-家电售卖与维修 | CHENKK-开发',
      systemNotice: ''
    }
  },
  async mounted() {
    // 加载系统设置
    await this.loadSystemSettings()
  },
  methods: {
    toggleDrawer() {
      this.showDrawer = !this.showDrawer
    },
    
    // 加载系统设置
    async loadSystemSettings() {
      try {
        const settings = await settingsService.getPublicSettings()
        
        // 更新数据
        this.siteName = settings.site_name || '永盛制冷维修有限公司'
        this.companyPhone = settings.company_phone || ''
        this.companyAddress = settings.company_address || ''
        this.serviceHours = settings.service_hours || '24小时服务'
        this.icpRecord = settings.icp_record || ''
        this.copyrightText = settings.copyright_text || '© 2025 永盛制冷维修有限公司-家电售卖与维修 | CHENKK-开发'
        this.systemNotice = settings.system_notice || ''
        
        // 动态更新页面标题
        if (this.siteName) {
          document.title = this.siteName
        }
        
      } catch (error) {
        console.error('加载系统设置失败:', error)
        // 使用默认值，不显示错误信息
      }
    }
  }
}
</script>

<style>
@import './styles/mobile-fixes.css';

#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #f5f5f5;
}

/* 全局版权信息样式 */
.global-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
  padding: 10px 0;
  font-size: 12px;
  z-index: 50;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
}

.footer-content p {
  margin: 3px 0;
  line-height: 1.4;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  font-weight: 500;
}

.icp-info {
  opacity: 0.9;
  font-size: 11px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

/* 为页面内容添加底部边距，避免被版权信息遮挡 */
#app {
  padding-bottom: 60px;
}

/* 移动端全局适配 */
@media (max-width: 768px) {
  /* 全局背景优化 */
  body {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
  }

  /* 移动端版权信息调整 */
  .global-footer {
    padding: 8px 15px;
    font-size: 11px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    backdrop-filter: blur(20px);
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  .footer-content p {
    margin: 2px 0;
    line-height: 1.4;
    color: #495057;
    font-weight: 500;
  }

  .icp-info {
    font-size: 10px;
    color: #6c757d;
  }

  #app {
    padding-bottom: 55px;
  }

  /* 移动端通用样式 */
  .el-container {
    flex-direction: column !important;
  }

  .el-header {
    height: auto !important;
    padding: 10px 15px !important;
  }

  .el-main {
    padding: 15px !important;
  }

  /* 移动端表格适配 */
  .el-table {
    font-size: 12px;
  }

  .el-table th,
  .el-table td {
    padding: 8px 5px !important;
  }

  /* 移动端表单适配 */
  .el-form-item {
    margin-bottom: 15px !important;
  }

  .el-form-item__label {
    line-height: 1.2 !important;
    padding-bottom: 5px !important;
  }

  /* 移动端按钮适配 */
  .el-button {
    padding: 8px 15px !important;
    font-size: 13px !important;
  }

  .el-button--small {
    padding: 6px 10px !important;
    font-size: 12px !important;
  }

  /* 移动端卡片适配 */
  .el-card {
    margin-bottom: 15px !important;
  }

  .el-card__body {
    padding: 15px !important;
  }

  /* 移动端对话框适配 */
  .el-dialog {
    width: 95% !important;
    margin: 5vh auto !important;
  }

  .el-dialog__body {
    padding: 15px !important;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.page-header {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,.12), 0 0 6px rgba(0,0,0,.04);
}

.page-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,.12), 0 0 6px rgba(0,0,0,.04);
}

/* 不同端的主题色 */
.customer-theme {
  --primary-color: #409EFF;
  --primary-light: #ecf5ff;
}

.worker-theme {
  --primary-color: #67C23A;
  --primary-light: #f0f9ff;
}

.admin-theme {
  --primary-color: #E6A23C;
  --primary-light: #fdf6ec;
}
</style>
